<template>
    <div>
        <el-button type="text" @click="dialogFormVisible = true">Edit</el-button>

        <el-dialog :title="'Edit Area: ' + area.name" :visible.sync="dialogFormVisible">
            <p>An area defines a space with a single significant volume of air or a HVAC zone.</p>

            <form method="#" action="#" @submit.prevent>
                <fg-input label="Area name" type="text" v-model="form.name"></fg-input>
                <fg-input label="Site">
                    <el-select class="select-default" v-model="form.place_id">
                        <el-option v-for="place in places" :key="place.id" class="select-default" :label="place.name" :value="place.id"></el-option>
                    </el-select>
                </fg-input>
                <fg-input label="Floor" type="text" v-model="form.floor"></fg-input>
            </form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="submit">Confirm</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import api from '@/api';
    import { Button, Dialog, Form, FormItem, Col, Select, Option } from 'element-ui'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            [Button.name]: Button,
            [Dialog.name]: Dialog,
            [Form.name]: Form,
            [Col.name]: Col,
            [FormItem.name]: FormItem,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        props: {
            'area': Object
        },
        data() {
            return {
                'dialogFormVisible': false,
                'form': {
                    'name': this.area.name,
                    'place_id': this.area.place_id,
                    'floor': this.area.floor,
                }
            };
        },
        computed: {
            ...mapGetters([
                'places'
            ])
        },
        methods: {
            submit: async function () {
                const area = await api.updateArea(this.area.area_hashid, this.form);

                this.$emit('areaUpdated', area);

                this.dialogFormVisible = false;
            }
        },
        watch:{
            'dialogFormVisible': async function (new_value) {
                if (new_value === true) {
                    const devices = await api.getAreaDevices(this.area.area_hashid);
                }
            },
        }
    };
</script>
